<template>
    <div ref="hoverReference" />
    <Teleport to="body">
        <div ref="hoverElement" v-tooltip.top="{ value: props.tooltipText, showDelay: 100 }" class="hover-element" />
    </Teleport>
</template>

<script lang="ts" setup>
import {
    ref, watch,
} from 'vue';
import { useMouse, useParentElement } from '@vueuse/core';
import type { UseMouseEventExtractor } from '@vueuse/core';

const props = defineProps<{
    tooltipText: string;
}>();

const hoverElement = ref<HTMLElement | null>(null);
const hoverReference = ref<HTMLElement | null>(null);

const extractor: UseMouseEventExtractor = (event) => {
    if (typeof Touch !== 'undefined' && event instanceof Touch) return null;
    const e = event as MouseEvent;
    return [e.offsetX, e.offsetY];
};

const mouseWithExtractor = ref(useMouse({ target: useParentElement(hoverReference), type: extractor }));
const mouse = ref(useMouse());

watch(() => mouseWithExtractor.value, () => {
    if (hoverElement.value) {
        hoverElement.value.style.top = `${mouse.value.y - 10}px`;
        hoverElement.value.style.left = `${mouse.value.x - 10}px`;
    }
}, { deep: true, immediate: true });
</script>

<style lang="scss" scoped>
.hover-element {
    position: fixed;
    height: 20px;
    width: 20px;
    z-index: 9999;
}
</style>
